import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react';
import { Stack, Dialog } from '@mui/material';
import genericError from './generic-error-sad-face.json';

const GenericErrorDialog = ({ open }) => {
  const handleClose = () => {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  };
  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="sm">
      <Stack alignItems="center" justifyContent="center">
        <Lottie animationData={genericError} loop style={{ maxWidth: '200px', maxHeight: '200px' }} />
      </Stack>
    </Dialog>
  );
};

GenericErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
};

export default GenericErrorDialog;
